import React from "react";
import { Box } from "grommet";
import { FrostedGlassBox } from "../../components";

// Matches the frosted-glass card look used elsewhere in the app (see
// MetricsSection, LinksSection, etc.) instead of a plain unstyled Box.
const Panel = ({ children, boxProps, ...rest }) => (
    <FrostedGlassBox {...rest}>
        <div className="container">
            <Box pad="medium" gap="small" {...boxProps}>
                {children}
            </Box>
        </div>
    </FrostedGlassBox>
);

export { Panel };
